import { PERMS } from '@/config/permissions';
import DefaultLayout from '@/layouts/DefaultLayout.vue';

const BusinessReport = () => import('@/modules/report/business/BusinessReport.vue');
const CostWarning = () => import('@/modules/report/cost-warning/CostWarning.vue');

export const reportRoutes = {
  path: '/report',
  name: 'Report',
  component: DefaultLayout,
  meta: {
    title: '报表分析',
    titleKey: 'route.report',
    icon: 'PieChart',
    order: 1,
  },
  children: [
    {
      path: 'business',
      name: 'BusinessReport',
      component: BusinessReport,
      meta: {
        title: '业务报表',
        titleKey: 'route.businessReport',
        icon: 'bar-chart',
        order: 50,
        permissions: [PERMS.REPORT_BUSINESS_VIEW],
      },
    },
    {
      path: 'cost-warning',
      name: 'CostWarning',
      component: CostWarning,
      meta: {
        title: '成本预警',
        titleKey: 'route.costWarning',
        icon: 'alert',
        order: 51,
        permissions: [PERMS.COST_WARNING_RECORD_VIEW],
      },
    },
  ],
};
